import React from 'react';

export type Granularity = 'days' | 'weeks' | 'months';

interface TimeRangeFilterProps {
  value: Granularity;
  onChange: (g: Granularity) => void;
  className?: string;
}

const OPTIONS: { value: Granularity; label: string }[] = [
  { value: 'days', label: 'D' },
  { value: 'weeks', label: 'W' },
  { value: 'months', label: 'M' },
];

const TimeRangeFilter: React.FC<TimeRangeFilterProps> = ({ value, onChange, className = '' }) => {
  return (
    <div className={`inline-flex items-center bg-gray-100/80 dark:bg-gray-700/60 rounded-md p-0.5 ${className}`}>
      {OPTIONS.map((opt) => {
        const isActive = value === opt.value;
        return (
          <button
            key={opt.value}
            onClick={(e) => {
              e.stopPropagation();
              onChange(opt.value);
            }}
            className={`px-2 py-0.5 text-[10px] font-medium rounded transition-all duration-150 leading-tight ${
              isActive
                ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 shadow-sm'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
            }`}
            title={opt.value.charAt(0).toUpperCase() + opt.value.slice(1)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default TimeRangeFilter;
